import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createCanteen } from "../../../redux/actions/canteenActions";
import { useLanguage } from "../../../context/LanguageContext";

const SectionIFoodHygiene = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const [form, setForm] = useState({
    i1: "",
    i1Remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  /* ================================
     SAVE & SUBMIT SECTION I
  ================================ */
  const isAttempted = form.i1 !== "";

  const isComplete = () => {
    if (!form.i1) return false;

    // If remarks required for specific options
    if ((form.i1 === "3" || form.i1 === "4") && !form.i1Remarks.trim()) {
      return false;
    }

    return true;
  };

  const isPartial = isAttempted && !isComplete();
  
  const handleSubmit = async () => {
    try {
      // Save locally
      const surveyData = JSON.parse(localStorage.getItem("surveyData") || "{}");
      surveyData.sectionI = form;
      localStorage.setItem("surveyData", JSON.stringify(surveyData));

      const completedSections = JSON.parse(
        localStorage.getItem("completedSections") || "{}",
      );
      completedSections.i = true;
      localStorage.setItem(
        "completedSections",
        JSON.stringify(completedSections),
      );

      // Prepare FormData for API
      const payload = new FormData();
      payload.append("municipality_id", state?.municipality_id || "1");
      payload.append("ward_id", state?.ward_id || "5");
      payload.append("district_id", state?.district_id || "10");
      payload.append(
        "lattitude_longitude",
        state?.lattitude_longitude || "22.5726,88.3639",
      );
      payload.append("survey_canteen_type", "kiosk");
      payload.append("program_name", "demo kiosk");
      payload.append("current_section", "food_hygine");
      payload.append("kiosk_location_fulladdress", state?.address || "yeWWW");
      payload.append("area_id", state?.area_id || "2");
      payload.append("canteen_type_id", state?.canteen_type || "2");
      payload.append("reporting_date", new Date().toISOString().split("T")[0]);
      payload.append("food_hygine_I1", form.i1);
      payload.append("food_hygine_I1_remarks", form.i1Remarks || "");

      // Dispatch Redux action
      await dispatch(createCanteen(payload));

      navigate("/survey/sections", { state });
    } catch (err) {
      console.error("Error submitting Section I:", err);
      alert(t.global.alert_server_error);
    }
  };

  const plateOptions = [
    { value: "1", label: `1. ${t.modules.kiosk.sections.I.options.plateType[0]}` },
    { value: "2", label: `2. ${t.modules.kiosk.sections.I.options.plateType[1]}` },
    { value: "3", label: `3. ${t.modules.kiosk.sections.I.options.plateType[2]}` },
    { value: "4", label: `4. ${t.modules.kiosk.sections.I.options.plateType[3]}` },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">
                {t.modules.kiosk.sections.I.title}
              </h2>
              <p className="text-gray-600">
                {t.modules.kiosk.sections.I.subtitle || "Food serving materials and distribution methods"}
              </p>
            </div>
            <div className="text-sm bg-pink-100 text-pink-800 px-3 py-1 rounded-full">
              {state?.canteenId
                ? `${t.global.canteen_id_label} ${state.canteenId}`
                : state?.kioskId
                  ? `${t.global.canteen_id_label} ${state.kioskId}`
                  : t.global.na}
            </div>
          </div>

          <div className="space-y-6">
            {/* I1 */}
            <div className="border rounded-lg p-4">
              <label className="block font-medium mb-3">
                I1. {t.modules.kiosk.sections.I.questions.plateType}
              </label>
              <div className="space-y-3 mb-4">
                {plateOptions.map((option) => (
                  <label
                    key={option.value}
                    className={`flex items-center p-3 border rounded cursor-pointer ${form.i1 === option.value ? "bg-blue-50 border-blue-300" : ""}`}
                  >
                    <input
                      type="radio"
                      name="i1"
                      value={option.value}
                      checked={form.i1 === option.value}
                      onChange={handleChange}
                      className="mr-3 h-5 w-5"
                    />
                    <span>{option.label}</span>
                  </label>
                ))}
              </div>

              {(form.i1 === "3" || form.i1 === "4") && (
                <div className="mt-4">
                  <label className="block text-sm font-medium mb-2">
                    {t.global.remarks_label}
                  </label>
                  <textarea
                    name="i1Remarks"
                    placeholder={
                      form.i1 === "3"
                        ? "Specify what material plates are used..."
                        : "Specify how the food is distributed..."
                    }
                    className="w-full border p-3 rounded"
                    rows="3"
                    value={form.i1Remarks}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>

            {/* Buttons */}
            <div className="flex justify-between pt-6 border-t">
              <button
                onClick={() => navigate("/survey/sections", { state })}
                className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
              >
                {t.global.back_to_sections}
              </button>
              <button
                onClick={handleSubmit}
                disabled={!isAttempted}
                className={`px-6 py-3 rounded-lg transition ${
                  !isAttempted
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-green-600 text-white hover:bg-green-700"
                }`}
              >
                {t.global.submit_section_i || "Submit Section I"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionIFoodHygiene;